import cloneDeep from 'lodash/cloneDeep';
import axios from '../../http.service';
import * as TYPES from '../Enums/Contract.Templates.Enums';

export const getContractTemplates = (appointeeType, activeStatus, qualYear, query) => {
    let payload;
	return async (dispatch, getState) => {
        try {
            if (qualYear) {               
                var resp = await axios.get(`/api/v2/contracts/templates/${appointeeType}/${activeStatus}/${qualYear}?pagination=${JSON.stringify(query)}`);
            }
            else {                
                var resp = await axios.get(`/api/v2/contracts/templates/${appointeeType}/${activeStatus}?pagination=${JSON.stringify(query)}`);
            }
			const dataLength = Object.keys(resp.data).length;
			const dataUndefined = typeof resp.data.data === 'undefined';

			if (dataLength === 0) {
				payload = { data: [], total: 0, errors: [], message: '' };
			} else if (dataLength > 0 && dataUndefined) {
				payload = {
					data: [],
					total: 0,
					errors: typeof resp.data.errors !== 'undefined' ? resp.data.errors : [],
					message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
				};
			} else if (dataLength > 0 && !dataUndefined && typeof resp.data.data.data !== 'undefined') {
				if (query.exportData === false) {
					//_Get user input changes Data from redux store.
					let updatedData = getState().templates.updated;
					let updatedDataLength = updatedData.length;
					payload = {
						data: resp.data.data.data.map(o => {
							Object.assign(o, {
								archive: o.active === true ? 'Active' : 'Archived',
								isValidForArchive: true,
                                invalidArchiveMessage: []
                                
							});
							return o;
						}),
						total: resp.data.data.total,
						errors: resp.data.errors,
						message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
					};
					payload.dataCopy = cloneDeep(payload.data);
					payload.data.forEach(o => {
						// Set values in the table/page which are changed by user but not yet saved
						if (updatedDataLength > 0) {
							let matchData = updatedData.find(x => x.id === o.id);
							if (matchData !== undefined) {
								o.spareField1 = matchData.spareField1;
								o.spareField2 = matchData.spareField2;
								o.spareField3 = matchData.spareField3;
								o.spareField4 = matchData.spareField4;
								o.spareField5 = matchData.spareField5;
								o.spareField6 = matchData.spareField6;
								o.spareField7 = matchData.spareField7;
								o.spareField8 = matchData.spareField8;
								o.spareField9 = matchData.spareField9;
								o.spareField10 = matchData.spareField10;
                                o.archive = matchData.archive;
                                
                                
							}
						}
					});
				} else {
					payload = {
						data: resp.data.data.data.map(o =>
							Object.assign(o, {
								archive: o.active === true ? 'Active' : 'Archived'
							})
						),
						errors: resp.data.errors,
						message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
					};
				}
			} else {
				payload = { data: [], dataCopy: [], total: 0, errors: [], message: '' };
			}

			return resp.status === 200
				? dispatch({
					type: !query.exportData ? TYPES.CONTRACT_TEMPLATES_GET : TYPES.CONTRACT_TEMPLATES_GET_ALL,
					payload
				})
				: dispatch({ type: TYPES.CONTRACT_TEMPLATES_ERROR, payload });
		} catch (error) {
			dispatch({
				type: TYPES.CONTRACT_TEMPLATES_ERROR,
				payload: {
					data: [],
					dataCopy: [],
					total: 0,
					errors: ['Error while fetching Template Data', error.message],
					message: ''
				}
			});
		}
	};
};

export const removeUpdate = (keyField, id, updates = []) => {
	return dispatch => {
		try {
			const _updates = updates.filter(update => update[keyField] !== id);
			dispatch({
				type: TYPES.CONTRACT_TEMPLATES_ADD_UPDATE,
				payload: {
					updates: _updates,
					errors: []
				}
			});
		} catch (err) {
			dispatch({
				type: TYPES.CONTRACT_TEMPLATES_ERROR,
				payload: {
					errors: [err.message]
				}
			});
		}
	}
};

export const addUpdateToTemplates = (field, val, row, updates = []) => {
	return dispatch => {
		try {
			let _updates;
			if (updates.filter(x => x.id === row.id).length > 0) {
				_updates = updates.map(x => {
					return x.id !== row.id ? x : { ...x, [field]: val };
				});
			} else {
				_updates = [...updates, row];
			}
			_updates.forEach(item => {
				const { archive } = item;
				item.active = archive === 'Active';
			});

			dispatch({
				type: TYPES.CONTRACT_TEMPLATES_ADD_UPDATE,
				payload: {
					updates: _updates,
					errors: []
				}
			});
		} catch (err) {
			dispatch({
				type: TYPES.CONTRACT_TEMPLATES_ERROR,
				payload: {
					errors: [err.message]
				}
			});
		}
	};
};

export const removeAllEdits = () => {
	return (dispatch, getState) => {
		const { templates: { dataCopy } } = getState();
		const data = cloneDeep(dataCopy);
		dispatch({
			type: TYPES.CONTRACT_TEMPLATES_REMOVE_ALL_EDITS,
			payload: {
				data
			}
		});
	};
};

export const clearAllTemplatesUpdates = () => dispatch => dispatch({ type: TYPES.CONTRACT_TEMPLATE_CLEAR_ALL_UPDATES, payload: {} });

export const saveUpdatedContractTemplates = (appointeeType, activeStatus, query, updates) => {
	return async dispatch => {
		try {

			if (updates.length <= 0)
				return dispatch({
					type: TYPES.CONTRACT_TEMPLATES_ERROR,
					payload: {
						message: 'Unable to Save Data',
						errors: ['No Changes to Save']
					}
				});

			//_Includes only specific columns that are required to update and excluded columns names are mentioned in "updates.map" method.
			let updatesSpecificColumns = updates.map(({ name, version, archive, isValidForArchive, invalidArchiveMessage, lastUpdated, ...item }) => item);

			let resp = await axios.put(`/api/v2/contracts/templates/${appointeeType}/${activeStatus}?pagination=${JSON.stringify(query)}`, {
				updates: updatesSpecificColumns
			});

			let payload;
			const dataLength = Object.keys(resp.data).length;
			const dataUndefined = typeof resp.data.data === 'undefined';

			if (dataLength === 0) {
				payload = { data: [], total: 0, errors: [], message: '' };
			} else if (dataLength > 0 && dataUndefined) {
				payload = {
					//_Not updating data & total due to some errors occured and nothing saved.
					errors: typeof resp.data.errors !== 'undefined' ? resp.data.errors : [],
					message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
				};
			} else if (dataLength > 0 && !dataUndefined && typeof resp.data.data.data !== 'undefined') {
				payload = {
					...resp.data,
					data: resp.data.data.data.map(o =>
						Object.assign(o, {
							archive: o.active === true ? 'Active' : 'Archived',
							isValidForArchive: true,
							invalidArchiveMessage: []
						})
					),
					total: resp.data.data.total,
					errors: resp.data.errors
				};
			} else {
				payload = { data: [], total: 0, errors: [], message: '' };
			}
			payload.dataCopy = cloneDeep(payload.data);

			return resp.status === 200 ? dispatch({ type: TYPES.CONTRACT_TEMPLATES_SAVE, payload }) : dispatch({ type: TYPES.CONTRACT_TEMPLATES_ERROR, payload });
		} catch (error) {
			return dispatch({
				type: TYPES.CONTRACT_TEMPLATES_ERROR,
				payload: {
					data: [],
					dataCopy: [],
					total: 0,
					errors: ['Error while saving updates', error.message],
					message: ''
				}
			});
		}
	};
};

export const addTemplateError = (error = '') => {
	return dispatch =>
		dispatch({
			type: TYPES.CONTRACT_TEMPLATES_ERROR,
			payload: { message: 'An Error Occured', errors: [error] }
		});
};

export const clearUpdateTemplateErrors = () => {
	return dispatch =>
		dispatch({
			type: TYPES.CONTRACT_TEMPLATE_CLEAR,
			payload: { message: '', errors: [] }
		});
};

export const getTemplateRelatedMarkingTeams = templateId => {
	let payload = {
		templateRelatedMarkingTeams: [],
		selectedTemplateId: templateId,
		errors: [],
		message: ''
	};
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/contracts/templates/${templateId}`);

			if (Object.keys(resp.data).length > 0 && typeof resp.data.data === 'undefined')
				payload = {
					templateRelatedMarkingTeams: [],
					selectedTemplateId: templateId,
					errors: typeof resp.data.errors !== 'undefined' ? resp.data.errors : [],
					message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
				};
			else if (Object.keys(resp.data).length > 0 && typeof resp.data.data !== 'undefined')
				payload = {
					templateRelatedMarkingTeams: resp.data.data,
					selectedTemplateId: templateId,
					errors: resp.data.errors,
					message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
				};

			return resp.status === 200
				? dispatch({
					type: TYPES.CONTRACT_TEMPLATES_GET_RELATED_MARKINGTEAMS,
					payload
				})
				: dispatch({ type: TYPES.CONTRACT_TEMPLATES_ERROR, payload });
		} catch (error) {
			dispatch({
				type: TYPES.CONTRACT_TEMPLATES_ERROR,
				payload: {
					templateRelatedMarkingTeams: [],
					selectedTemplateId: templateId,
					errors: ['Error while fetching Template Related Marking Teams.', error.message],
					message: ''
				}
			});
		}
	};
};
